﻿import React, {  Fragment, useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { parseDate } from '../../../../../Resources/Scripts/_Shared/parseDate';

const CampaignItem = ({ campaign }) => {
	const currentLanguage = document.querySelector('html').getAttribute('lang');
	const sameMonth = moment(parseDate(campaign.DateTo)).isSame(parseDate(campaign.DateFrom), 'month');
	const sameYear = moment(parseDate(campaign.DateTo)).isSame(parseDate(campaign.DateFrom), 'year');

	return (
		<li>
			<a href={campaign.Url}>
				{campaign.Image && <img src={campaign.ImageSrc} />}
				<div>
					<h4>{campaign.Heading}</h4>
					{(campaign.DateFrom || campaign.DateTo) &&
						<span>{(campaign.DateFrom ? moment(campaign.DateFrom).add(6, 'hours').locale(currentLanguage).format(sameMonth ? 'D' : sameYear ? 'D MMM' : 'D MMM YYYY') : '') + '–' + (campaign.DateTo ? moment(campaign.DateTo).add(6, 'hours').locale(currentLanguage).format(sameYear ? 'D MMM' : 'D MMM YYYY') : '')}</span>}
				</div>
			</a>
		</li>
  )
}

export default CampaignItem;
